import React, { useEffect, useState } from "react";
import API from "util/Api";
import SnackBar from "components/SnackBar";
import ContainerHeader from "components/ContainerHeader";
import _ from "lodash";
import * as Yup from "yup";
import CardBox from "components/CardBox";
import ActionsTable from "components/ActionsTable/TableList";
import SimpleTable from "components/ActionsTable/SimpleTable";
import EZForm, { getFieldValues } from "components/EZForm";
import ResetDialog from "./ResetDialog";


const LoopData = (props) => {
    const [config, setConfig] = useState();
    const [loopData, setLoopData] = useState();
    const [fieldValues, setFieldValues] = useState();
    const [dialog, setDialog] = useState({ open: false });
    const [snackBar, setSnackBar] = useState({
        open: false,
        message: "",
        type: "error",
    });

    const validations = Yup.object().shape({
        location: Yup.object().required("Required")
    });

    useEffect(() => {
        API.get("loopData")
            .then((res) => {
                setConfig(res.data.data.config);
            })
            .catch((err) => {
                setSnackBar({
                    open: true,
                    message: err?.response?.data?.msg ? err.response.data.msg : "Something went wrong",
                    type: "error",
                });
            });
    }, []);

    const handleSubmit = (data, form) => {
        API.post("loopData", JSON.stringify(data))
            .then((res) => {
                setLoopData(res.data.data);
                form.setSubmitting(false);
            })
            .catch((err) => {
                console.log("error", err);
                form.setSubmitting(false);
                setSnackBar({
                    open: true,
                    message: err?.response?.data?.msg ? err.response.data.msg : "Something went wrong",
                    type: "error",
                });
            });
    };

    return (
        config &&
        <>
            <ContainerHeader title={config?.title} match={props.match} />
            <EZForm
                fields={Object.values(config.fields)}
                values={fieldValues}
                validationSchema={validations}
                onSubmit={handleSubmit}
            />
            {loopData && (
                <div className="row">
                    <CardBox styleName="col-12">
                        <SimpleTable
                            type={'loopData'}
                            table={loopData}
                            onReset={(row) => { setDialog({ open: true, data: row }) }}
                        />
                    </CardBox>
                </div>

            )}
            <SnackBar
                {...snackBar}
                handleClose={() => {
                    setSnackBar(prevState => ({ ...prevState, open: false, message: "" }));
                }}
            />
            <ResetDialog
                dialog={dialog}
                setDialog={setDialog}
                setLoopData={setLoopData}
            />
        </>
    )
}
export default LoopData;